import * as React from 'react';
import { Loader } from '../Loader';
import { injectIntl, useIntl } from 'react-intl';
import { TranslateText } from '../TranslateText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Icon Widget component with props and its types
const _DualListWidgetV2 = props => {
  const {
    loader,
    title,
    width,
    column1Value,
    column2Value,
    imageAlt,
    imageTooltip,
    disabled,
    image
  } = props;
  const intl = useIntl();
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-dual-list-v2 ${disabled && "kc-ui-disabled "}  ${loader && "kc-ui-loader-overlay"}`,
      style: {
        width: `${width}`
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "kc-ui-colm-div",
        children: [title ? /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsx(TranslateText, {
            id: title
          })
        }) : null, loader ? /*#__PURE__*/_jsx(Loader, {
          loader: loader
        }) : /*#__PURE__*/_jsx("div", {
          className: `kc-ui-colmiVal`,
          children: /*#__PURE__*/_jsxs("div", {
            className: `kc-ui-dual-v2-status-div`,
            children: [/*#__PURE__*/_jsx("img", {
              src: image,
              className: "kc-ui-dual-v2-status-image",
              alt: imageAlt ? intl.formatMessage({
                id: imageAlt
              }) : '',
              title: imageTooltip ? intl.formatMessage({
                id: imageTooltip
              }) : ''
            }), /*#__PURE__*/_jsx("div", {
              children: column1Value?.map((status, index) => {
                return index === 0 ? /*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx(TranslateText, {
                    id: status.label
                  })
                }) : /*#__PURE__*/_jsx("p", {
                  children: /*#__PURE__*/_jsx(TranslateText, {
                    id: status.label
                  })
                });
              })
            }), /*#__PURE__*/_jsx("div", {
              children: column2Value?.map((status, index) => {
                return index === 0 ? /*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx(TranslateText, {
                    id: status.label
                  })
                }) : /*#__PURE__*/_jsx("p", {
                  children: /*#__PURE__*/_jsx(TranslateText, {
                    id: status.label
                  })
                });
              })
            })]
          })
        })]
      })
    })
  });
};
_DualListWidgetV2.defaultProps = {
  loader: false,
  title: '',
  width: '100%',
  disabled: false,
  column1Value: [],
  column2Value: [],
  image: '',
  imageAlt: '',
  imageTooltip: ''
};

/**
 * Widget to display list of status and description
 */
export const DualListWidgetV2 = injectIntl( /*#__PURE__*/React.memo(_DualListWidgetV2));